import { BaseMethod } from "./_Base";
import { DecomposedPath } from "../../../core/DecomposedPath";
export class ChExpression extends BaseMethod {
  constructor() {
    super(...arguments);
    this._requireDependency = true;
  }
  static requiredArguments() {
    return [["string", "path to param"]];
  }
  findDependency(indexOrPath) {
    const decomposedPath = new DecomposedPath();
    const param = this.getReferencedParam(indexOrPath, decomposedPath);
    if (param) {
      this._referencedParam = param;
      return this.createDependency(param, indexOrPath, decomposedPath);
    }
    return null;
  }
  async processArguments(args) {
    return new Promise(async (resolve, reject) => {
      let val = 0;
      if (args.length == 1) {
        const path = args[0];
        const ref = this._referencedParam || this.getReferencedParam(path);
        if (ref) {
          if (ref.isDirty()) {
            await ref.compute();
          }
          const result = ref.value;
          if (result != null) {
            val = result;
            resolve(val);
          }
        } else {
          reject(0);
        }
      }
    });
  }
}
